<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ການອອກໃບຢັ້ງຢືນ ( ຂັ້ນ{{  section}} )
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 25 || roleid == 26 || roleid == 27 ||  roleid == 28">
        <b-tab-item label="ຂັ້ນແຂວງ" >
          <div class="columns scrollme" v-if="roleid == 25">
            <div class="column">
              <b-field label="ລາຍການຂັ້ນແຂວງ" >
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="20%">
                        ຊື່ແຂວງ
                      </th>
                      <th class="has-text-centered " width="30%">
                        ຈຳນວນເມືອງ
                      </th>
                      <th class="has-text-centered " width="30%">
                        ຈຳນວນກຸ່ມ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ຈຳນວນຟອມ
                      </th>
                      <th class="has-text-centered " width="20%">
                        ເລືອກແຂວງ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in provinceList" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td  >
                        {{ data.PROVINCENAME }}
                      </td>
                      <td  class="has-text-centered">
                        {{ data.NUMOFDISTRICT  }}
                      </td>
                      <td  class="has-text-centered">
                        {{ data.NUMOFGROUP  }}
                      </td>
                      <td  class="has-text-centered">
                        {{ data.NUMOFFORM  }}
                      </td>

                      <td class="has-text-centered">
                        <b-field>
                          <b-button
                            class="btn-group-margin"
                            type="is-primary"
                            size="is-small"
                            @click="
                              getPreIcsDistrict(data)
                            "
                            >ເລືອກແຂວງ
                          </b-button>
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ຂັ້ນເມືອງ" >
          <b-field v-if="!isProvinceSelected" >
            <button class="button is-info" @click="gotoProvincelist" v-if="roleid == 25">
              ເລືອກແຂວງ
            </button>
          </b-field>
          <b-field v-else>
            <div class="columns scrollme" >
              <div class="column">
                <b-field label="ລາຍການຂັ້ນເມືອງ" >
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="20%">
                          ຊື່ເມືອງ 
                        </th>
                        <th class="has-text-centered " width="30%">
                          ຈຳນວນກຸ່ມ
                        </th>
                        <th class="has-text-centered " width="15%">
                          ຈຳນວນຟອມ
                        </th>
                        <th class="has-text-centered " width="20%">
                          ເລືອກເມືອງ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in districtList" :key="data.ID">
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td  >
                          {{ data.DISTRICTNAME }}
                        </td>
                        <td  class="has-text-centered">
                          {{ data.NUMOFGROUP  }}
                        </td>
                        <td  class="has-text-centered">
                          {{ data.NUMOFFORM  }}
                        </td>

                        <td class="has-text-centered">
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                getIcsGroup(data)
                              "
                              >ເລືອກເມືອງ
                            </b-button>
                          </b-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-field>
              </div>
            </div>
          </b-field>

          
        </b-tab-item>
        <b-tab-item label="ຂັ້ນກຸ່ມ">
          <b-field v-if="!isDistrictSelected" >
            <button class="button is-info" @click="gotoDistrictlist" v-if="roleid == 26">
              ເລືອກເມືອງ
            </button>
          </b-field>
          <b-field v-else>
            <div class="columns scrollme">
              <div class="column">
                <b-field :label="selectedDistrictName">
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="40%">
                          ຊື່ກຸ່ມ
                        </th>
                        <th class="has-text-centered " width="15%">
                          ຈຳນວນຟອມ
                        </th>
                        <th class="has-text-centered " width="20%">
                          ຈັດການ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in groupList" :key="data.ID">
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td  >
                          {{ data.GROUPNAME }}
                        </td>
                        <td  class="has-text-centered">
                          {{ data.NUMOFFARM  }}
                        </td>

                        <td class="has-text-centered">
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                getIcsFarm(data)
                              "
                              >ເລືອກກຸ່ມ  -
                            </b-button>
                          </b-field>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-field>
              </div>
            </div>
          </b-field>
          
        </b-tab-item>

        <b-tab-item label="ຊາວກະສິກອນ">
          
          <b-field v-if="!isGroupSelected">
            <button class="button is-info" @click="gotoGrouplist">
              ເລືອກກຸ່ມ
            </button>
          </b-field>
          <b-field v-else>
            <div class="columns scrollme" v-if=" roleid ==28">
              <div class="column">
                <b-field :label="selectedGroupName">
                  ລາຍຊື່ຟາມພາຍໃນກຸ່ມ
                  <table class="table is-narrow is-small" width="70%">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="30%">
                          ຊື່ຟາມ/ ເບີໂທ
                        </th>
                        <th   class="has-text-centered" width="15%">
                          ອອກໃບຢັ້ງຢືນ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in farmList" :key="data.ID">
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td  >
                          {{ data.FARMNAME }} / {{ data.FARMPHONENO }}
                        </td>
                        
                        <td  class="has-text-centered">
                          <b-field>
                              <b-button
                                class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  prepareToCertify(data)
                                "
                                >+ ອອກໃບຢັ້ງຢືນ
                              </b-button>
                          </b-field>
                        </td>

                       
                      </tr>
                    </tbody>
                  </table>
                </b-field>
              </div>

              <div class="column">
                <b-field :label="selectedGroupName">
                  ຟາມທີ່ຕ້ອງການອອກໃບຢັ້ງຢືນ
                  <table class="table is-fullwidth is-narrow is-small">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="30%">
                          ຊື່ຟາມ/ ເບີໂທ
                        </th>
                        <th   class="has-text-centered" width="15%">
                          ຍົກເລີກ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in farmWaitList" :key="data.ID">
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td  >
                          {{ data.FARMNAME }} / {{ data.FARMPHONENO }}
                        </td>
                        
                        <td  class="has-text-centered">
                          <b-field>
                              <b-button
                                class="btn-group-margin"
                                type="is-danger"
                                size="is-small"
                                @click="
                                  cancelToCertify(data)
                                "
                                >- ຍົກເລີກ
                              </b-button>
                          </b-field>
                        </td>

                       
                      </tr>
                    </tbody>
                  </table>
                  
                </b-field>
                <b-field >
                  <b-datepicker
                          :date-formatter="dateFormatter"
                          v-model="verification_date"
                          placeholder="ວັນທີ"
                  >
                  </b-datepicker>
                </b-field>
                <b-field >
                          <Multiselect
                            placeholder="ເລືອກ"
                            v-model.trim="verification_type"
                            label="NAME"
                            track-by="ID"
                            :options="verification_typeList"
                          >
                          </Multiselect>
                        </b-field>
                <b-field >
                  <b-field >
                    <b-input maxlength="200" v-model.trim="verification_remark"  type="textarea" placeholder="ລາຍລະອຽດ"></b-input>
                  </b-field>
                </b-field>
                <b-field class="has-text-right">
                      <b-button
                        class="btn-group-margin"
                        type="is-primary"
                        size="is-small"
                        @click="
                          confirmToCertify()
                        "
                        >ຢືນຢັນລາຍການຂໍອອກໃບຢ້້ງຢືນ
                      </b-button>
                </b-field>
                <br>
                <b-field>
                  ລາຍການຟອມຂໍອອກໃບຢັ້ງຢືນ
                  <table class="table is-narrow is-small" width="100%">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="10%">
                          ເລກທີຟອມ
                        </th>
                        <th class="has-text-left " width="10%">
                          ປະເພດຟອມ
                        </th>
                        <th class="has-text-left " width="10%">
                          ວັນທີ
                        </th>
                        <th class="has-text-left " width="30%">
                          ເນື້ອໃນ
                        </th>
                        <th class="has-text-left " width="10%">
                          ລາຍລະອຽດ
                        </th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in waitCertificationFarmList" :key="data.ID">
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td  >
                          {{ data.ID }}
                        </td>
                        <td>
                          <b-field v-if="data.TYPE==1">
                            ຟອມດ່ຽວ
                          </b-field>
                          <b-field v-if="data.TYPE==2">
                            ຟອມລວມກຸ່ມ
                          </b-field>
                        </td>
                        <td  >
                          {{ data.FORMDATE }}
                        </td>
                        <td  >
                          {{ data.GROUPREMARK }}
                        </td>
                        
                        <td  class="has-text-centered">
                          <b-field>
                              <b-button
                                class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  getViolationDetail(data.ID)
                                "
                                > ລາຍລະອຽດ
                              </b-button>
                          </b-field>
                        </td>

                       
                      </tr>
                    </tbody>
                  </table>
                </b-field>
              </div>
            </div>

            <div class="columns scrollme" v-if=" roleid !=28">
              <div class="column">
                <b-field :label="selectedGroupName">
                  ລາຍການຟອມຂໍອອກໃບຢັ້ງຢືນ
                  <table class="table is-narrow is-small" width="100%">
                    <thead>
                      <tr>
                        <th class="has-text-centered " width="5%">#</th>
                        <th class="has-text-left " width="10%">
                          ເລກທີຟອມ
                        </th>
                        <th class="has-text-left " width="10%">
                          ປະເພດຟອມ
                        </th>
                        <th class="has-text-left " width="10%">
                          ວັນທີ
                        </th>
                        <th class="has-text-left " width="30%">
                          ເນື້ອໃນ
                        </th>
                        <th class="has-text-left " width="10%">
                          ລາຍລະອຽດ
                        </th>
                        
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in waitCertificationFarmList" :key="data.ID">
                        <td class="has-text-centered">{{ index + 1 }}</td>
                        <td  >
                          {{ data.ID }}
                        </td>
                        <td>
                          <b-field v-if="data.TYPE==1">
                            ຟອມດ່ຽວ
                          </b-field>
                          <b-field v-if="data.TYPE==2">
                            ຟອມລວມກຸ່ມ
                          </b-field>
                        </td>
                        <td  >
                          {{ data.FORMDATE }}
                        </td>
                        <td  >
                          {{ data.GROUPREMARK }}
                        </td>
                        
                        <td  class="has-text-centered">
                          <b-field>
                              <b-button
                                class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  getViolationDetail(data.ID)
                                "
                                > ລາຍລະອຽດ
                              </b-button>
                          </b-field>
                        </td>

                       
                      </tr>
                    </tbody>
                  </table>
                </b-field>
              </div>
            </div>

          </b-field>
        </b-tab-item>

        <b-tab-item label="ລາຍລະອຽດການຂໍໃບຢັ້ງຢືນ">
          <div v-if="!isDetailCertificationSelected">
            <button class="button is-info" @click="gotoFarmlist">
              ເລືອກຟາມ
            </button>
          </div>
          <div v-else>                
            <div class="columns" >
              <div class="column">
                ການອະນຸມັດໃບຢັ້ງຢືນ ແຕ່ລະຂັ້ນ
                <table width="100%" class="table ">
                  <thead>
                    <tr>
                      <th class="has-text-left " width="10%">
                        ຂັ້ນ
                      </th>
                      <th class="has-text-centered " width="15%">
                        ວັນທີ
                      </th>
                      <th class="has-text-centered " width="10%">
                        ສະຖານະ
                      </th>
                      <th class="has-text-left " width="70%">
                        ລາຍລະອຽດ
                      </th>
                      <th class="has-text-centered " width="5%">
                        ຈັດການ
                      </th>
                    </tr>   
                    <tr v-if="violation_groupdetailcount != 0 ">
                      <th class="has-text-left "  >
                        ຂັ້ນກຸ່ມ 
                      </th>
                      <th class="has-text-centered ">
                        <b-field >
                          {{ violation_groupdetailcheckdate }}
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        ຜູ້ສະເໜີ
                      </th>
                      <th class="has-text-left ">
                        <b-field >
                          {{ violation_groupdetailremark }}
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        
                      </th>
                    </tr>
                    <!-- ຂັ້ນເມືອງ -->
                    <tr v-if="violation_districtdetailcount === 0 && roleid ==27">
                      <th class="has-text-left "  >
                        ຂັ້ນເມືອງ
                      </th>
                      <th class="has-text-centered ">
                        <b-field >
                          <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="violation_districtdate"
                                  placeholder="ວັນທີ"
                          >
                          </b-datepicker>
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        <b-field >
                          <Multiselect
                            placeholder="ເລືອກ"
                            v-model.trim="violation_districtstatus"
                            label="NAME"
                            track-by="ID"
                            :options="statusList"
                          >
                          </Multiselect>
                        </b-field>
                      </th>
                      <th class="has-text-centered ">
                        <b-field >
                          <b-input maxlength="200" v-model.trim="violation_districtremark"  type="textarea" placeholder="ລາຍລະອຽດ"></b-input>
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        <b-field >
                          <button class="button is-info" @click="saveViolationDistrict" >
                            ບັນທຶກ
                          </button>
                        </b-field>
                      </th>
                    </tr>
                    <tr v-if="violation_districtdetailcount != 0 && (roleid ==27 || roleid ==26 || roleid ==25)">
                      <th class="has-text-left "  >
                        ຂັ້ນເມືອງ
                      </th>
                      <th class="has-text-centered ">
                        <b-field >
                          {{ violation_districtdetailcheckdate }}
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        <b-field v-if="violation_districtdetailstatus==1" class="statusLabel-passed">
                          ເຫັນດີ
                        </b-field>
                        <b-field v-if="violation_districtdetailstatus==0" class="statusLabel-warning">
                          ບໍ່ເຫັນດີ
                        </b-field>
                      </th>
                      <th class="has-text-left ">
                        <b-field >
                          {{ violation_districtdetailremark }}
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        
                      </th>
                    </tr>
                    <!-- ຂັ້ນແຂວງ -->
                    <tr v-if="violation_provincedetailcount === 0 && roleid ==26">
                      <th class="has-text-left "  >
                        ຂັ້ນແຂວງ
                      </th>
                      <th class="has-text-centered ">
                        <b-field >
                          <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="violation_provincedate"
                                  placeholder="ວັນທີ"
                          >
                          </b-datepicker>
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        <b-field >
                          <Multiselect
                            placeholder="ເລືອກ"
                            v-model.trim="violation_provincestatus"
                            label="NAME"
                            track-by="ID"
                            :options="statusList"
                          >
                          </Multiselect>
                        </b-field>
                      </th>
                      <th class="has-text-centered ">
                        <b-field >
                          <b-input maxlength="200" v-model.trim="violation_provinceremark"  type="textarea" placeholder="ລາຍລະອຽດ"></b-input>
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        <b-field >
                          <button class="button is-info" @click="saveViolationProvince" >
                            ບັນທຶກ 
                          </button>
                        </b-field>
                      </th>
                    </tr>
                    <tr v-if="violation_provincedetailcount != 0 && (roleid ==26 || roleid ==25)">
                      <th class="has-text-left "  >
                        ຂັ້ນແຂວງ
                      </th>
                      <th class="has-text-centered ">
                        <b-field >
                          {{ violation_provincedetailcheckdate }}
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        <b-field v-if="violation_provincedetailstatus==1" class="statusLabel-passed">
                          ເຫັນດີ
                        </b-field>
                        <b-field v-if="violation_provincedetailstatus==0" class="statusLabel-warning">
                          ບໍ່ເຫັນດີ
                        </b-field>
                      </th>
                      <th class="has-text-left ">
                        <b-field >
                          {{ violation_provincedetailremark }}
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        
                      </th>
                    </tr>
                    <!-- ຂັ້ນສູນກາງ -->
                    <tr v-if="violation_centerdetailcount === 0 && roleid ==25">
                      <th class="has-text-left "  >
                        ຂັ້ນສູນກາງ
                      </th>
                      <th class="has-text-centered ">
                        <b-field >
                          <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="violation_centerdate"
                                  placeholder="ວັນທີ"
                          >
                          </b-datepicker>
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        <b-field >
                          <Multiselect
                            placeholder="ເລືອກ"
                            v-model.trim="violation_centerstatus"
                            label="NAME"
                            track-by="ID"
                            :options="statusList"
                          >
                          </Multiselect>
                        </b-field>
                      </th>
                      <th class="has-text-centered ">
                        <b-field >
                          <b-input maxlength="200" v-model.trim="violation_centerremark"  type="textarea" placeholder="ລາຍລະອຽດ"></b-input>
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        <b-field >
                          <button class="button is-info" @click="saveViolationCenter" >
                            ບັນທຶກ 
                          </button>
                        </b-field>
                      </th>
                    </tr>
                    <tr v-if="violation_centerdetailcount != 0 && roleid ==25">
                      <th class="has-text-left "  >
                        ຂັ້ນສູນກາງ
                      </th>
                      <th class="has-text-centered ">
                        <b-field >
                          {{ violation_centerdetailcheckdate }}
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        <b-field v-if="violation_centerdetailstatus==1" class="statusLabel-passed">
                          ເຫັນດີ
                        </b-field>
                        <b-field v-if="violation_centerdetailstatus==0" class="statusLabel-warning">
                          ບໍ່ເຫັນດີ
                        </b-field>
                      </th>
                      <th class="has-text-left ">
                        <b-field >
                          {{ violation_centerdetailremark }}
                        </b-field>
                      </th>
                      <th class="has-text-centered " >
                        
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    
                  </tbody>
                </table>
                
              </div>
            </div>

          </div>
        </b-tab-item>

      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      userName: null,
      roleid: null,

      activeTab: 0,
      provinceList: [],
      districtList: [],
      groupList: [],
      farmList: [],
      farmWaitList: [],
      productionList: [],
      productionSelected: [],
      oarecordlist: [],
      isProvinceSelected: false,
      isDistrictSelected: false,
      isGroupSelected: false,
      isProductionTypeSelected: false,
      isProductionDetailSelected: false,
      isViolationformSelected: false,
      selectedDistrictName: "",
      selectedGroupName: "",
      selectedFarmName: "",
      selectedType: "",
      type: "",

      oarecord_groupdate: null,
      oarecord_groupstatus: null,
      oarecord_groupremark: null,
      oarecord_districtdate: null,
      oarecord_districtstatus: null,
      oarecord_districtremark: null,
      oarecord_provincedate: null,
      oarecord_provincestatus: null,
      oarecord_provinceremark: null,

      selectedFarmID : null,
      selectedFarmerID: null,
      selectedcropid : null,

      statusList: [{"ID":"1","NAME":"ເຫັນດີ"},{"ID":"0","NAME":"ບໍ່ເຫັນດີ"}],

      oarecord_groupdetailcount: null,
      oarecord_groupdetailcheckdate: null,
      oarecord_groupdetailstatus: null,
      oarecord_groupdetailremark: null,

      oarecord_districtdetailcount: null,
      oarecord_districtdetailcheckdate: null,
      oarecord_districtdetailstatus: null,
      oarecord_districtdetailremark: null,

      oarecord_provincedetailcount: null,
      oarecord_provincedetailcheckdate: null,
      oarecord_provincedetailstatus: null,
      oarecord_provincedetailremark: null,


      violation_groupdate: null,
      violation_groupstatus: null,
      violation_groupremark: null,
      violation_districtdate: null,
      violation_districtstatus: null,
      violation_districtremark: null,
      violation_provincedate: null,
      violation_provincestatus: null,
      violation_provinceremark: null,
      violation_centerdate: null,
      violation_centerstatus: null,
      violation_centerremark: null,

      violation_groupdetailcount: null,
      violation_groupdetailcheckdate: null,
      violation_groupdetailstatus: null,
      violation_groupdetailremark: null,

      violation_districtdetailcount: null,
      violation_districtdetailcheckdate: null,
      violation_districtdetailstatus: null,
      violation_districtdetailremark: null,

      violation_provincedetailcount: null,
      violation_provincedetailcheckdate: null,
      violation_provincedetailstatus: null,
      violation_provincedetailremark: null,

      violation_centerdetailcount: null,
      violation_centerdetailcheckdate: null,
      violation_centerdetailstatus: null,
      violation_centerdetailremark: null,

      provinceid_of_agrizone_province: null,
      agrizone_provinceid: null,
      agrizone_districtid: null,
      agrizone_groupid: null,
      agrizone_groupname: null,
      section: null,
      agri_data: [],

      verification_date: null,
      verification_remark: null,
      verification_typeList: [{"ID":"1","NAME":"ໃບຍັງຢືນດ່ຽວ"},{"ID":"2","NAME":"ໃບຢັ້ງຢືນກຸ່ມ"}],
      verification_type: null,
      waitCertificationFarmList: [],
      isDetailCertificationSelected: false,
      selectedFormID: null,

    };
  },
  methods: {
    prepareToCertify(data) {
        console.log("params:", JSON.stringify(data))
        var params = {
          farmid: data.ID,
          groupid: data.ZONEID,
          username: this.username
        };
        RestAPI.addToCertification(params)
          .then(() => {
            this.$swal("ສ້າງຂໍ້ມູນ ສຳເລັດ!", "", "success");
            this.getIcsFarm(this.agri_data);
            this.getIcsWaitFarm(this.agri_data);
            
            this.getAgrizoneDetail(4,this.agrizone_groupid);
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
    },
    cancelToCertify(data) {
        // console.log("params:", JSON.stringify(data))
        var params = {
          farmid: data.ID,
          groupid: data.ZONEID
        };
        RestAPI.cancelToCertification(params)
          .then(() => {
            this.$swal("ລືບຂໍ້ມູນ ສຳເລັດ!", "", "success");
            this.getIcsFarm(this.agri_data);
            this.getIcsWaitFarm(this.agri_data);
            this.getAgrizoneDetail(4,this.agrizone_groupid);
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
    },
    confirmToCertify() {
      this.$swal({
        title: "ຕ້ອງານດຳເນີນການແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6"
      }).then(result => {
        if (result.value) {
          var params = {
            groupid: this.agrizone_groupid,
            date: this.dateFormatterYYYYMMDD(this.verification_date),
            remark: this.verification_remark,
            type: this.verification_type.ID,
            username: this.username
          };
          console.log("params: " + JSON.stringify(params));
          RestAPI.confirmToCertification(params)
            .then(() => {
              // console.log("res: " + JSON.stringify(res.data))
              // this.getViolationDetail();
              this.$swal("ບັນທືກລາຍການ ສຳເລັດ!", "", "success");
              this.getIcsFarm(this.agri_data);
              this.getIcsWaitFarm(this.agri_data);
              this.getAgrizoneDetail(4,this.agrizone_groupid);
              this.verification_remark =null;
              this.verification_date = new Date();
              this.verification_type= [];
            })
            .catch(error => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    getWaitCertificationFarm() {
      RestAPI.getWaitCertificationFarm(this.agrizone_groupid)
        .then(res => {
          console.log("res: "+ JSON.stringify(res.data))
          this.waitCertificationFarmList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    violationForm(data){
      this.selectedFarmID = data.ID;
      this.selectedFarmerID = data.FARMERID;
      this.isViolationformSelected = true;
      this.activeTab = 6;
      // this.getViolationDetail();
    },
    getIcsProvince() {
      // console.log("this.userProvinceID: " + this.userProvinceID)
      RestAPI.getCertificationProvince()
        .then(res => {
          this.provinceList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getPreIcsDistrict(data){
      console.log("data: "+ JSON.stringify(data));
      this.agrizone_provinceid =data.ID;
      this.getIcsDistrict();
    },
    getIcsDistrict() {
     this.activeTab =1;
     this.isProvinceSelected = true;
      RestAPI.getCertificationDistrict(this.agrizone_provinceid)
        .then(res => {
          console.log(" res.data: " + JSON.stringify( res.data))
          this.districtList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getIcsGroup(data) {
      this.selectedDistrictName= "ເມືອງ: " + data.DISTRICTNAME;
      this.isDistrictSelected= true;
      this.activeTab = 2;
      // console.log("this.userProvinceID: " + this.userProvinceID)
      RestAPI.getCertificationGroup(data.ID)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.groupList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    gotoProvincelist(){
      this.activeTab = 0;
    },

    gotoDistrictlist(){
      this.activeTab = 1;
    },
    gotoGrouplist(){
      this.activeTab = 2;
    },

    gotoFarmlist(){
      this.activeTab = 3;
    },
    gotoProductionlist(){
      this.activeTab = 4;
    },
    getIcsFarm(data) {
      this.agrizone_groupid = data.ID;
      this.getWaitCertificationFarm();
      this.selectedGroupName= this.selectedDistrictName+"/ " + data.GROUPNAME;
      this.isGroupSelected= true;
      this.activeTab = 3;
      RestAPI.getVerificationFarm(data.ID)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.farmList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getIcsWaitFarm(data) {
      this.selectedGroupName= this.selectedGroupName? this.selectedGroupName : this.selectedDistrictName+"/ " + data.GROUPNAME;
      this.isGroupSelected= true;
      this.activeTab = 3;
      RestAPI.getWaitVerificationFarm(data.ID)
        .then(res => {
          console.log("farmWaitList:"+ JSON.stringify(res.data))
          this.farmWaitList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getIcsProduction(data, type) {
      this.type = type;
      this.selectedFarmName= this.selectedGroupName+ "/ " + data.FARMNAME;
      this.isProductionTypeSelected= true;
      this.activeTab = 4;
      RestAPI.getViolationProduction(data.ID, type)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.productionList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getIcsProductionDetail(data) {
      this.selectedFarmID = data.ID;
      this.selectedFarmerID = data.FARMERID;
      this.selectedcropid = data.MARKETPRODUCTIONID;
      this.oarecord_groupdetail= [];
      this.getOARecordDetail();
      
      if(this.type==1){
        this.selectedType= this.selectedFarmName+ "/ ຜະລິດຕາມຕະຫຼາດ";
      }else if(this.type==2){
        this.selectedType= this.selectedFarmName+ "/ ຜະລິດຕາມສັນຍາ";
      }else{
        this.activeTab=4;
      }
     
      this.isProductionDetailSelected= true;
      this.activeTab = 5;

      RestAPI.getIcsProductionDetail(this.type,this.selectedcropid)
        .then(res => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.productionSelected = res.data.productionSelected;
          this.oarecordlist = res.data.oarecordlist;
          
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getOARecordDetail(){
      RestAPI.getOARecordDetail(this.selectedcropid)
        .then(res => {
          
          // console.log("res.data.group.detail[0]: "+ res.data.group.detail[0])
          
          if(res.data.group.count > 0){
            this.oarecord_groupdetailcount = res.data.group.count;
            this.oarecord_groupdetailcheckdate =  res.data.group.detail[0].GROUPRECORDDATE;
            this.oarecord_groupdetailstatus =  res.data.group.detail[0].GROUPSTATUS;
            this.oarecord_groupdetailremark =  res.data.group.detail[0].GROUPREMARK;
          }else{
            this.oarecord_groupdetailcount = 0;
            this.oarecord_groupdetailcheckdate =  '';
            this.oarecord_groupdetailstatus =  '';
            this.oarecord_groupdetailremark =  '';
          }


          if(res.data.district.count > 0){
            this.oarecord_districtdetailcount = res.data.district.count;
            this.oarecord_districtdetailcheckdate =  res.data.district.detail[0].DISTRICTRECORDDATE;
            this.oarecord_districtdetailstatus =  res.data.district.detail[0].DISTRICTSTATUS;
            this.oarecord_districtdetailremark =  res.data.district.detail[0].DISTRICTREMARK;
          }else{
            this.oarecord_districtdetailcount = 0;
            this.oarecord_districtdetailcheckdate =  '';
            this.oarecord_districtdetailstatus =  '';
            this.oarecord_districtdetailremark =  '';
          }

          if(res.data.province.count > 0){
            this.oarecord_provincedetailcount = res.data.province.count;
            this.oarecord_provincedetailcheckdate =  res.data.province.detail[0].PROVINCERECORDDATE;
            this.oarecord_provincedetailstatus =  res.data.province.detail[0].PROVINCESTATUS;
            this.oarecord_provincedetailremark =  res.data.province.detail[0].PROVINCEREMARK;
          }else{
            this.oarecord_provincedetailcount = 0;
            this.oarecord_provincedetailcheckdate =  '';
            this.oarecord_provincedetailstatus =  '';
            this.oarecord_provincedetailremark =  '';
          }
          
          
        })
        .catch(error => {
          console.log(error); 
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    saveViolationGroup() {
      // console.log("violation_groupdate: ", this.violation_groupdate);
      // console.log("violation_groupstatus: ", this.violation_groupstatus);
      // console.log("violation_groupremark: ", this.violation_groupremark);
      if (
        this.violation_groupdate === null ||
        this.violation_groupstatus === null || 
        this.violation_groupremark === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      } else {
        var params = {
          famerid: this.selectedFarmerID,
          farmid: this.selectedFarmID,
          cropid: this.selectedcropid,
          violatedate: this.dateFormatterYYYYMMDD(this.violation_groupdate),
          groupcheckid: this.username,
          groupstatus: this.violation_groupstatus.ID,
          groupremark: this.violation_groupremark,
          username: this.username
        };

        // console.log("params:", JSON.stringify(params))
        RestAPI.saveViolationGroup(params)
          .then(() => {
            this.$swal("ສ້າງຂໍ້ມູນ ສຳເລັດ!", "", "success");
            this.violation_groupdate = null;
            this.violation_groupstatus = null;
            this.violation_groupremark = null;
            // this.getViolationDetail();
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    
    saveViolationDistrict() {
      if (
        this.violation_districtdate === null ||
        this.violation_districtstatus === null || 
        this.violation_districtremark === null 
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      } else {
        var params = {
          formid: this.selectedFormID,
          formdate: this.dateFormatterYYYYMMDD(this.violation_districtdate),
          districtcheckid: this.username,
          districtstatus: this.violation_districtstatus.ID,
          districtremark: this.violation_districtremark,
          username: this.username
        };

        console.log("params:", JSON.stringify(params))
        RestAPI.saveCertificationDistrict(params)
          .then(() => {
            this.$swal("ສ້າງຂໍ້ມູນ ສຳເລັດ!", "", "success");
            this.violation_distirctdate = null;
            this.violation_districtstatus = null;
            this.violation_districtremark = null;
            this.getViolationDetail(this.selectedFormID);
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },

    saveViolationProvince() {
      if (
        this.violation_provincedate === null ||
        this.violation_provincestatus === null || 
        this.violation_provinceremark === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      } else {
        var params = {
          formid: this.selectedFormID,
          formdate: this.dateFormatterYYYYMMDD(this.violation_provincedate),
          provincecheckid: this.username,
          provincestatus: this.violation_provincestatus.ID,
          provinceremark: this.violation_provinceremark,
          username: this.username
        };

        // console.log("params:", JSON.stringify(params))
        RestAPI.saveCertificationProvince(params)
          .then(() => {
            this.$swal("ສ້າງຂໍ້ມູນ ສຳເລັດ!", "", "success");
            this.violation_provincedate = null;
            this.violation_provincestatus = null;
            this.violation_provinceremark = null;
            this.getViolationDetail(this.selectedFormID);
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },
    saveViolationCenter() {
      if (
        this.violation_centerdate === null ||
        this.violation_centerstatus === null || 
        this.violation_centerremark === null
      ) {
        this.$swal("ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບຖ້ວນ", "", "error");
        return false;
      } else {
        var params = {
          formid: this.selectedFormID,
          formdate: this.dateFormatterYYYYMMDD(this.violation_centerdate),
          centercheckid: this.username,
          centerstatus: this.violation_centerstatus.ID,
          centerremark: this.violation_centerremark,
          username: this.username
        };

        // console.log("params:", JSON.stringify(params))
        RestAPI.saveCertificationCenter(params)
          .then(() => {
            this.$swal("ສ້າງຂໍ້ມູນ ສຳເລັດ!", "", "success");
            this.violation_centerdate = null;
            this.violation_centerstatus = null;
            this.violation_centerremark = null;
            this.getViolationDetail(this.selectedFormID);
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },

    // violation
    getViolationDetail(formid){
      this.activeTab = 4;
      this.isDetailCertificationSelected = true;
      this.selectedFormID = formid;
      RestAPI.getCertificationDetail(formid) // formid 
        .then(res => {
          
          console.log("res.data.group.detail[0]: "+ JSON.stringify(res.data.group));
          
          if(res.data.group.count > 0){
            this.violation_groupdetailcount = res.data.group.count;
            this.violation_groupdetailcheckdate =  res.data.group.detail[0].GROUPCERTIFICATIONDATE;
            this.violation_groupdetailstatus =  res.data.group.detail[0].GROUPSTATUS;
            this.violation_groupdetailremark =  res.data.group.detail[0].GROUPREMARK;
          }else{
            this.violation_groupdetailcount = 0;
            this.violation_groupdetailcheckdate =  '';
            this.violation_groupdetailstatus =  '';
            this.violation_groupdetailremark =  '';
          }


          if(res.data.district.count > 0){
            this.violation_districtdetailcount = res.data.district.count;
            this.violation_districtdetailcheckdate =  res.data.district.detail[0].DISTRICTCHECKDATE;
            this.violation_districtdetailstatus =  res.data.district.detail[0].DISTRICTSTATUS;
            this.violation_districtdetailremark =  res.data.district.detail[0].DISTRICTREMARK;
          }else{
            this.violation_districtdetailcount = 0;
            this.violation_districtdetailcheckdate =  '';
            this.violation_districtdetailstatus =  '';
            this.violation_districtdetailremark =  '';
          }

          if(res.data.province.count > 0){
            this.violation_provincedetailcount = res.data.province.count;
            this.violation_provincedetailcheckdate =  res.data.province.detail[0].PROVINCECHECKDATE; 
            this.violation_provincedetailstatus =  res.data.province.detail[0].PROVINCESTATUS;
            this.violation_provincedetailremark =  res.data.province.detail[0].PROVINCEREMARK;
          }else{
            this.violation_provincedetailcount = 0;
            this.violation_provincedetailcheckdate =  '';
            this.violation_provincedetailstatus =  '';
            this.violation_provincedetailremark =  ''; 
          }

          if(res.data.center.count > 0){
            this.violation_centerdetailcount = res.data.center.count;
            this.violation_centerdetailcheckdate =  res.data.center.detail[0].CENTERCHECKDATE; 
            this.violation_centerdetailstatus =  res.data.center.detail[0].CENTERSTATUS;
            this.violation_centerdetailremark =  res.data.center.detail[0].CENTERREMARK;
          }else{
            this.violation_centerdetailcount = 0;
            this.violation_centerdetailcheckdate =  '';
            this.violation_centerdetailstatus =  '';
            this.violation_centerdetailremark =  '';

          }
          
          
        })
        .catch(error => {
          console.log(error); 
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
    getAgrizoneDetail(type,id) {
      RestAPI.getAgrizoneDetail(type,id)
        .then(res => {
          // console.log("getAgrizoneDetail :"+ JSON.stringify(res.data))
          if(type==3){
            this.selectedDistrictName = res.data[0]['PROVINCENAME']+ "/" + res.data[0]['DISTRICTNAME'];
          }else if(type==4){
            this.selectedGroupName= res.data[0]['PROVINCENAME']+ "/" + res.data[0]['DISTRICTNAME'] +"/ " + res.data[0]['GROUPNAME'];
          }

          // this.districtList = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    print() {
      window.print();
    }
  },
  mounted() {
    // console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.agrizone_provinceid= this.user.AGRIZONE_PROVINCEID ? this.user.AGRIZONE_PROVINCEID : '';
    this.provinceid_of_agrizone_province = this.user.PROINCEID_OF_AGRIZONE_PROVINCE ? this.user.PROINCEID_OF_AGRIZONE_PROVINCE : '';
    this.agrizone_districtid= this.user.AGRIZONE_DISTRICTID ? this.user.AGRIZONE_DISTRICTID : '';
    this.agrizone_districtname= this.user.AGRIZONE_DISTRICTNAME ? this.user.AGRIZONE_DISTRICTNAME : '';
    this.agrizone_groupname= this.user.GROUPNAME ? this.user.GROUPNAME : '';
    this.agrizone_groupid= this.user.GROUPID ? this.user.GROUPID : '';
    this.userProvinceID = this.user.BRANCHPROVNICEID ? this.user.BRANCHPROVNICEID : 'all';

    // console.log("this.user: " + JSON.stringify(this.user));
    // console.log("this.agrizone_groupid: "+ JSON.stringify(this.agrizone_groupid));
    

    this.section =
      this.user.ROLEID == 25
        ? "ສູນກາງ"
        : this.user.ROLEID == 26
        ? "ແຂວງ"
        : this.user.ROLEID == 27
        ? "ເມືອງ"
        : this.user.ROLEID == 28
        ? "ກຸ່ມ"
        : "";
    this.oarecord_groupdate = new Date();
    this.oarecord_distirctdate = new Date();
    this.oarecord_provnicedate = new Date();

    this.verification_date = new Date();

     console.log("this.user.ROLEID: "+ this.user.ROLEID)
     console.log("agrizone_provinceid: "+ this.agrizone_provinceid)
    
     if(this.user.ROLEID==25){
      this.activeTab = 0;
      this.getIcsProvince();
    }else if(this.user.ROLEID==26){
      this.activeTab =1;
      this.getIcsDistrict();
    }else if(this.user.ROLEID==27){
      this.agri_data['DISTRICTNAME']=this.agrizone_districtname;
      this.agri_data['ID']=this.agrizone_districtid
      this.getAgrizoneDetail(3,this.agrizone_districtid);
      this.getIcsGroup(this.agri_data);
    }else if(this.user.ROLEID==28){
      
      this.isDetailCertificationSelected = true;
      this.agri_data['GROUPNAME']=this.agrizone_groupname;
      this.agri_data['ID']=this.agrizone_groupid
      //console.log("agri_data-: "+ JSON.stringify(this.agri_data))
      this.getAgrizoneDetail(4,this.agrizone_groupid);
      // console.log("this.selectedGroupName: "+ this.selectedGroupName)
      this.getIcsFarm(this.agri_data);
      this.getIcsWaitFarm(this.agri_data);
      this.getWaitCertificationFarm();
    }
   
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
